import React, {Component} from "react";
import './square.css';

class Square extends Component{
    constructor(props){
        super(props);
        this.handleClick=this.handleClick.bind(this);
    }
    handleClick(evt){
        this.props.flipCells();
    }
    render(){
        let classes = "square-"+ (this.props.colour? "dark": "light")
        return(
            <td className={classes} onClick={this.handleClick}></td>
        );
    }
}

export default Square;